<script>
import { mapState } from 'pinia';
import { mapActions } from 'pinia';
import { useCartStore } from '../stores/cart.js';
import ajaxRequest from "../utils/ajaxRequest.js";
import showMessage from "../utils/showMessage.js";
import TelInput from "../components/TelInput.vue";
import pluralizeAndApply from "../utils/pluralizeAndApply";

export default {
    components: {
        TelInput
    },
    props: {
        cartContacts: String
    },
    data() {
        return {
            loading: false,
            productsItems: null,
            fields: {
                name: "",
                phone: "",
                privacy_consent: false,
                // email: "",
                // company: "",
                // comment: "",
            },
            errors: {
                name: false,
                phone: false,
                privacy_consent: false,
                // email: false,
                // company: false,
                // comment: false
            }
        };
    },
    computed: {
        ...mapState(useCartStore, {
            cartList: "list"
        }),
        productsItemsCount() {
            let countStr = pluralizeAndApply(
                this.productsItems.length, 
                this.$s("STR_CART_PRODUCTS_COUNT").split("|"), 
                window.Application.config.lang_code
            );
            
            return countStr;
        },
    },
    methods: {
        ...mapActions(useCartStore, {
            "inCart": "inCart",
            "changeCart": "change"
        }),
        async load() {
            const data = Object.assign({
                list: this.cartList,
            }, window.Application.config);

            this.loading = true;
            const response = await ajaxRequest("/__ajax/cart/products", data);
            this.loading = false;

            if (response && response.code == 0 && response.msgData.productsItems) {
                this.productsItems = response.msgData.productsItems;
            } else {
                this.productsItems = null;
            }
        },
        async submitOrder() {
            this.loading = true;
            if (!this.validateForm()) {
                this.loading = false;
                showMessage("Ошибка в заполнении формы");
                return;
            }

            const data = {
                userData: {
                    name: this.fields.name,
                    phone: this.fields.phone,
                    email: this.fields.email,
                    company: this.fields.company,
                    comment: this.fields.comment,
                    privacy_consent: this.fields.privacy_consent ? "1" : "",
                },
                comment: this.fields.comment,
                products: this.productsItems
            };

            const response = await ajaxRequest("/__ajax/cart/submitOrder", data);
            this.loading = false;

            if (response && response.code == 0) {
                this.productsItems.forEach((product) => {
                    this.changeCart(product.id, 0);
                });
                window.location.href = response.msgData.redirect;
            } else if (response && response.code == 1 && response.displayMsg) {
                showMessage(response.displayMsg);
            } else {
                showMessage(this.$s("STR_ORDER_ERROR"));
            }
        },
        validateForm() {
            let isValid = true;

            if (!this.fields.name) {
                this.errors.name = true;
                isValid = false;
            }
            if (!this.fields.phone) {
                this.errors.phone = true;
                isValid = false;
            }
            if (!this.fields.privacy_consent) {
                this.errors.privacy_consent = true;
                isValid = false;
            }

            return isValid;
        },
        decreaseQty(item) {
            if (item.quantity > 1) {
                this.changeCart(item.id, item.quantity - 1);
                item.quantity--;
            }
        },
        increaseQty(item) {
            if (item.quantity < 9999) {
                item.quantity++;
                this.changeCart(item.id, item.quantity);
            }
        },
        onInputQty(e, item) {
            const cleaned = item.quantity.toString().replace(/\D/g, "");
            if (cleaned === "") {
                item.quantity = 1; 
                e.target.value = "1";
                return;
            }
            
            let num = parseInt(cleaned, 10);
            
            if (num > 99999) {
                num = 99999;
            }
            if (num < 1) {
                num = 1;
            }

            item.quantity = num;
            e.target.value = num;
            
            this.changeCart(item.id, item.quantity);
        },
        removeItem(item) {
            this.changeCart(item.id, 0);
            this.productsItems = this.productsItems.filter(i => i.id !== item.id);
        },
        clearCart() {
            this.productsItems.forEach((product) => {
                this.changeCart(product.id, 0);
            });
        }
    },
    async mounted() {
        const cartStore = useCartStore();
        cartStore.setup();

        await this.load();
    }
};
</script>

<template>
    <form
        class="cart__page form"
        method="POST"
        action="/__ajax/cart/submitOrder"
        @submit.prevent="submitOrder"
        :class="{ loading: loading }"
    >
        <div class="centered-block big">
            <template v-if="cartList && cartList.length > 0">
                <template v-if="productsItems">
       
                    <div class="card__products">
                        <div class="count-title">{{ productsItemsCount }}</div>

                        <div class="product__items">
                            <div class="product__item" v-for="item in productsItems">
                                <a :href="item.link" class="product__item_image">
                                    <div class="product-image" v-if="item.images" v-html="item.images"></div>
                                    <div class="product-image" v-else><img :src="item.defaultSrc" alt="" class="img"></div>
                                </a>
                                <div class="product__item_data">
                                    <a :href="item.link" class="product__item_sku">
                                        {{ item.sku }}
                                    </a>
                                    <div class="product__item_preview" v-html="item.preview" v-if="item.preview"></div>
                                    <div class="product__item_replacement" v-if="item.replacement_text || item.replacement_sku_text">
                                        <div class="product__item_replacement-title">
                                            {{ $s("STR_REPLACEMENT_TITLE")}}
                                        </div>
                                        <div class="product__item_replacement-text">
                                            <div v-if="item.replacement_text">{{item.replacement_text}}</div>
                                            <div v-if="item.replacement_sku_text" v-html="item.replacement_sku_text"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="product__item_right">
                                    <div class="product__item_availab-st">
                                        {{ item.availab_title }}
                                    </div>

                                    <div class="price__block">
                                        <div class="product__item_price" v-if="item.price > 0 && $v('SITE_IS_SHOW_PRICES') == 'true'">
                                            {{ $priceFormat(item.price) }}
                                        </div>
                                        <div class="product__item_price" v-else>
                                            {{ $s("STR_PRICE_REQUEST") }}
                                        </div>
                                    </div>
                                    
                                    <div class="quantity__input">
                                        <button type="button" class="item__btn input__item_minus" @click="decreaseQty(item)">
                                            <svg-icon name="minus" class="icon"></svg-icon>
                                        </button>
    
                                        <div class="amount">
                                            <input type="text" class="input__field" v-model="item.quantity" @input="onInputQty($event, item)">
                                        </div>
    
                                        <button type="button" class="item__btn input__item_plus" @click="increaseQty(item)" >
                                            <svg-icon name="plus" class="icon"></svg-icon>
                                        </button>
                                    </div>
                                    
                                    <div class="price__block">
                                        <div class="product__item_price" v-if="item.price > 0 && $v('SITE_IS_SHOW_PRICES') == 'true'">
                                            {{ $priceFormat(item.price * item.quantity) }}
                                        </div>
                                        <div class="product__item_price" v-else>
                                            {{ $s("STR_PRICE_REQUEST") }}
                                        </div>
                                    </div>
                                    <div class="product__item_remove">
                                        <button type="button" class="remove-button" @click="removeItem(item)">
                                            <svg-icon name="close" class="icon"></svg-icon></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="product__items_bottom">
                            <div class="info__block" v-html="$s('STR_CART_PRICE_INFO')"></div>
                            <button type="button" class="clear-cart" @click="clearCart">{{ $s('STR_CLEAR_CART') }}</button>
                        </div>
                    </div>

                    <div class="cart__data">
                        <div class="cart__form_block">
                            <div class="title__block_sm">
                                {{ $s("STR_CART_FORM_TITLE") }}
                            </div>
                            <div class="form-block">
                                <div class="name-field floating-label-input" :class="{ 'field-error': errors.name }">
                                    <input class="input-field" name="name" ref="nameField" type="text"
                                        v-model="fields.name" placeholder="&nbsp;" required @input="errors.name = false" />
                                    <div class="input-label">{{ $s("STR_FORM_FULLNAME") }} *</div>
                                </div>
                                <div class="email-field floating-label-input" :class="{ 'field-error': errors.email }">
                                    <input class="input-field" ref="emailField" type="email"
                                        v-model="fields.email" name="email" placeholder="&nbsp;" @input="errors.email = false" />
                                    <div class="input-label">{{ $s("STR_FORM_EMAIL") }}</div>
                                </div>
                                <div class="telephone-field floating-label-input" :class="{ 'field-error': errors.phone }">
                                    <tel-input class="input-field" ref="telField" type="text" inputmode="phone"
                                        v-model="fields.phone" placeholder="&nbsp;" name="phone"
                                        pattern="\+7 \(\d{3,3}\) \d{3,3}-\d{2,2}-\d{2,2}" required />
                                    <div class="input-label">{{ $s("STR_FORM_CONTACT_PHONE") }} *</div>
                                </div>
                                <div class="name-field floating-label-input"
                                    :class="{ 'field-error': errors.company }">
                                    <input class="input-field" ref="nameField" type="text" name="company"
                                        v-model="fields.company" placeholder="&nbsp;" @input="errors.company = false" />
                                    <div class="input-label">{{ $s("STR_FORM_COMPANY") }} </div>
                                </div>
                                <div class="floating-label-input comment-section message-wrap">
                                    <textarea class="input-field" type="text" name="comment" v-model="fields.comment"
                                        :placeholder="$s('STR_FORM_COMMENT')"></textarea>
                                </div>
                                <div class="form-consent field-error-target" :class="{ 'field-error': errors.privacy_consent }">
                                    <label class="label__item form-consent__label">
                                        <input
                                            type="checkbox"
                                            name="privacy_consent"
                                            value="1"
                                            v-model="fields.privacy_consent"
                                            required
                                            @change="errors.privacy_consent = false"
                                        >
                                        <span class="text">Я даю согласие на сбор и обработку персональных данных и подтверждаю ознакомление с Политикой конфиденциальности.</span>
                                    </label>
                                </div>
                                <button type="submit" class="submit-button button">{{ $s("STR_SUBMIT_ORDER") }}</button>
                            </div>
                        </div>

                        <div v-html="cartContacts"></div>
                    </div>

                </template>
            </template>
            <template v-else>
                <div class="content-empty">{{ $s("STR_CART_EMPTY") }}</div>
            </template>
        </div>
    </form>
</template>
